import React, {createContext} from "react";
import {Farm} from "../Farms/types";
import {Contract} from 'web3-eth-contract'
import BigNumber from "bignumber.js";


export const StakeTopProvider: React.FC<{ model: FarmModel, children: any }> = (ev) => {
    return <StakeTopContext.Provider value={ev.model}>{ev.children}</StakeTopContext.Provider>
};


export const StakeTopContext = createContext<FarmModel>({
    total: new BigNumber(0),
    apy: new BigNumber(0),
    averageRrturns: new BigNumber(0),
    leverage: new BigNumber(0),
    staked: new BigNumber(0),
    returns:new BigNumber(0),

});

export interface FarmModel {
    total?: BigNumber,
    averageRrturns?: BigNumber,
    apy?: BigNumber,
    leverage?: BigNumber,
    staked?: BigNumber,
    userAllStakeBalance?:BigNumber,
    getTokenAmout?:BigNumber,
    returns?:BigNumber,
}
